module.exports = false;




// WEBPACK FOOTER //
// ./~/detect-node/browser.js